/* eslint-disable angular/factory-name */

angular.
module("dx.webapp.login").
factory("dxSessionExpiration", function dxSessionExpirationService(
	$cookies,
	$rootScope,
	$route,
	$location,

	dxSession,
	RoleTypeEnum,
	DX_URLS,

	dxDialog
) {
	"use strict";

	var dialogOpen = false;

	function isSessionExpired() {
		if (!$cookies.get("user") && dxSession.getRole().roleType !== RoleTypeEnum.PUB && !dialogOpen) {
			dialogOpen = true;
			var scope = $rootScope.$new();
			var mostRecentUserId = dxSession.getUser().id;

			scope.success = function success() {
				dialogOpen = false;
				if (dxSession.getUser().id !== mostRecentUserId) {
					$location.path(DX_URLS.get("overview"));
					$route.reload();
				}
			};

			dxDialog.show({
				templateUrl: "partials/popups/login.html",
				escapeToClose: false,
				clickOutsideToClose: false,
				$scope: scope,
			});

			return true;
		}

		return false;
	}

	return {
		isSessionExpired: isSessionExpired,
	};
});
